import React, { useState } from 'react';

import List from '../../atoms/List';
//import { useDialog } from '../../atoms/Dialog';
import { Conversation } from '../../../api';
//import useApi from '../../../hooks/useApi';
//import LoadingContainer from '../../hoc/LodingContainer';
import Formatter from '../../../services/Formatter';
import { useLocation } from 'react-router-dom';


/*"messageInBgColor": "#091E2E",
"messageInTextColor": "#FFF",
"messageOutBgColor": "#00A3E0",
"messageOutTextColor": "#FFF",*/


const ConversationDetail = () => {
    const location = useLocation();
    const { data, sessionId } = location.state || {};
    const [selectedRadek, setSelectedRadek] = useState<Conversation['sessionId'] | undefined>(undefined);
    //const { openDialog } = useDialog();

    return (
        <>
            <h1>Konverzace</h1>
            <div className='mt-32 w-100'>
                <List
                    title={sessionId}
                    columns={[
                        { key: 'timestamp', label: 'Timestamp', formatuj: Formatter.reshuffleDateTimeSec },
                        { key: 'answer', label: 'Odpověď' },
                        { key: 'question', label: 'Otázka' },
                    ]}
                    rows={data}
                    selectable='single'
                    selected={selectedRadek?.length ? [selectedRadek] : undefined}
                    onChangeSelect={(ids) => setSelectedRadek(ids.length ? ids[0] : undefined)}
                />
            </div>
        </>
    );
}

export default ConversationDetail;
